module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "book-preview"
  }, [_c('h2', [_vm._v(_vm._s(_vm.book.name))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.book.author))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.book.price))]), _vm._v(" "), _c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.book.imgUrl
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.editBook($event)
      }
    }
  }, [_vm._v("✎")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.deleteBook($event)
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addToCart($event)
      }
    }
  }, [_vm._v("Add to Cart")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb7f91a6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/books/BookPreview.vue
// module id = 299
// module chunks = 1